<template>
  <v-card class="mb-4">
    <v-card-title class="headline">
      Impostazioni Tabelle
      <v-spacer></v-spacer>
      <v-btn icon @click="resetSettings">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    
    <v-card-text>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Larghezza Colonne
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" sm="6" md="4" v-for="(width, column) in columnWidths" :key="column">
                <v-text-field
                  :label="getColumnLabel(column)"
                  type="number"
                  v-model.number="columnWidths[column]"
                  suffix="px"
                  outlined
                  dense
                  @change="saveColumnWidths"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        
        <v-expansion-panel>
          <v-expansion-panel-header>
            Ordine Colonne
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12">
                <draggable v-model="columnOrder" @end="saveColumnOrder" class="column-order-list">
                  <v-card
                    v-for="column in columnOrder"
                    :key="column"
                    outlined
                    class="mb-2 pa-2 d-flex align-center column-order-item"
                  >
                    <v-icon class="mr-2">mdi-drag</v-icon>
                    {{ getColumnLabel(column) }}
                  </v-card>
                </draggable>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        
        <v-expansion-panel>
          <v-expansion-panel-header>
            Altre Impostazioni
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="otherSettings.showLoadingOnPageChange"
                  label="Mostra indicatore di caricamento al cambio pagina"
                  @change="saveOtherSettings"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="otherSettings.useDashForEmptyDates"
                  label="Usa trattino per date vuote"
                  @change="saveOtherSettings"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="otherSettings.useChipForYear"
                  label="Usa chip per visualizzare l'anno"
                  @change="saveOtherSettings"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  v-model="otherSettings.reducedIconSpacing"
                  label="Riduci spazio tra le icone di azione"
                  @change="saveOtherSettings"
                ></v-switch>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'TableSettings',
  components: {
    draggable
  },
  data() {
    return {
      columnWidths: {
        cid: 80,
        project: 150,
        referent: 120,
        alert: 60,
        sottocosto: 100,
        anno: 80,
        insegna: 150
      },
      columnOrder: [
        'cid',
        'project',
        'referent',
        'sottocosto',
        'anno',
        'alert',
        'insegna'
      ],
      otherSettings: {
        showLoadingOnPageChange: true,
        useDashForEmptyDates: true,
        useChipForYear: true,
        reducedIconSpacing: false
      }
    };
  },
  created() {
    this.loadSettings();
  },
  methods: {
    getColumnLabel(column) {
      const labels = {
        cid: 'CID',
        project: 'Progetto',
        referent: 'Referente',
        alert: 'Alert',
        sottocosto: 'Sottocosto',
        anno: 'Anno',
        insegna: 'Insegna'
      };
      return labels[column] || column;
    },
    loadSettings() {
      // Carica le impostazioni dallo store
      if (this.$store.state.uiSettings && this.$store.state.uiSettings.tables) {
        const tableSettings = this.$store.state.uiSettings.tables;
        
        if (tableSettings.columnWidths) {
          this.columnWidths = { ...this.columnWidths, ...tableSettings.columnWidths };
        }
        
        if (tableSettings.columnOrder) {
          this.columnOrder = [...tableSettings.columnOrder];
        }
        
        if (tableSettings.otherSettings) {
          this.otherSettings = { ...this.otherSettings, ...tableSettings.otherSettings };
        }
      }
    },
    saveColumnWidths() {
      this.saveSettings();
    },
    saveColumnOrder() {
      this.saveSettings();
    },
    saveOtherSettings() {
      this.saveSettings();
    },
    saveSettings() {
      // Prepara le impostazioni da salvare
      const tableSettings = {
        tables: {
          columnWidths: { ...this.columnWidths },
          columnOrder: [...this.columnOrder],
          otherSettings: { ...this.otherSettings }
        }
      };
      
      // Salva le impostazioni nello store e sincronizza con il backend
      this.$store.dispatch('updateUISettings', tableSettings);
    },
    resetSettings() {
      // Ripristina le impostazioni predefinite
      this.columnWidths = {
        cid: 80,
        project: 150,
        referent: 120,
        alert: 60,
        sottocosto: 100,
        anno: 80,
        insegna: 150
      };
      
      this.columnOrder = [
        'cid',
        'project',
        'referent',
        'sottocosto',
        'anno',
        'alert',
        'insegna'
      ];
      
      this.otherSettings = {
        showLoadingOnPageChange: true,
        useDashForEmptyDates: true,
        useChipForYear: true,
        reducedIconSpacing: false
      };
      
      this.saveSettings();
    }
  }
};
</script>

<style scoped>
.column-order-list {
  width: 100%;
}

.column-order-item {
  cursor: move;
}
</style>
